import React, {useEffect, useState} from 'react';
import {Card, Dimmer, Loader} from 'semantic-ui-react';
import Header from '../commons/header';
import FloatInventoryTable from './table/floatInventoryTable';
import {connect} from 'react-redux';
import UploadFlInventoryFiles from './../../../budgetVehicles/components/common/uploadFiles';
import ModalOrderInfo from './modalOrderInfo/modalOrderInfo';
import {formFloatInvErrors} from '../../constants/initialErrors';

const Main = ({
  currentLineOriginal,
  floatingInventoryData,
  loading,
  loadingAll,
  filters,
}) => {
  const [filteredRowsData, setFilteredRowsData] = useState([]);
  const [showModalOrderInfo, setShowModalOrderInfo] = useState(false);
  const [currentLine, setCurrentLine] = useState({
    ...currentLineOriginal,
    'floatingState': currentLineOriginal?.floatingState === 'D' ? 'R' : (currentLineOriginal?.floatingState || ''),
  });
  const [currentLineError, setCurrentLineError] = useState(formFloatInvErrors);
  const [resetAllFilters, setResetAllFilters] = useState(false);

  useEffect(() => {
    if (!currentLineOriginal?.orderNumber) {
      setShowModalOrderInfo(false);
    }
  }, [currentLineOriginal]);
  
  return (
    <>
      <Dimmer inverted active={loading || loadingAll} style={{
        'width': '100%',
        'height': '100%',
        'position': 'fixed',
        'top': '0',
        'background': 'rgba(0, 0, 0, 0.5)',
      }}>
        <Loader size='large'/>
      </Dimmer>
      <Header
        filteredRows={filteredRowsData}
        setResetAllFilters={setResetAllFilters}
        filters={filters}
      />
      <Card raised fluid>
        <FloatInventoryTable
          dataTable={floatingInventoryData}
          setFilteredRowsData={setFilteredRowsData}
          setShowModalOrderInfo={setShowModalOrderInfo}
          showModalOrderInfo={showModalOrderInfo}
          setCurrentLine={setCurrentLine}
          setCurrentLineError={setCurrentLineError}
          resetAllFilters={resetAllFilters}
          setResetAllFilters={setResetAllFilters}
          filters={filters}
        />
      </Card>
      <UploadFlInventoryFiles />
      <ModalOrderInfo
        showModalOrderInfo={showModalOrderInfo}
        setShowModalOrderInfo={setShowModalOrderInfo}
        currentLine={currentLine}
        setCurrentLine={setCurrentLine}
        currentLineError={currentLineError}
        setCurrentLineError={setCurrentLineError}
        filters={filters}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    'loading': state.floatingInventory.loading,
    'loadingAll': state.floatingInventory.loadingAll,
    'floatingInventoryData': state.floatingInventory.floatingInventoryData,
    'isUserTde': state.session.isUserFromTDE,
    'currentLineOriginal': state.floatingInventory.currentLine,
  };
};

export default connect(mapStateToProps, {})(Main);
